import React from "react";

import CirclesContainer from "./shapes/CirclesContainer";
import RectanglesContainer from "./shapes/RectanglesContainer";
import {
  RoundedRectanglesContainerVertical,
  RoundedRectanglesContainerHorizontal,
} from "./shapes/RoundedRectanglesContainer";

const Modular = () => {
  const roundedRectangles = [
    {
      width: 100,
      height1: 140,
      height2: 150,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 55,
      height2: 145,
      colors: { default: "#b0b0b0", active: "#0C82DC" },
    },
    {
      width: 100,
      height1: 95,
      height2: 115,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 55,
      height2: 90,
      colors: { default: "#3DD695" },
    },
    {
      width: 100,
      height1: 155,
      height2: 110,
      colors: { default: "#3DD695" },
    },
    {
      width: 100,
      height1: 55,
      height2: 15,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 90,
      height2: 60,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 95,
      height2: 50,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 155,
      height2: 175,
      colors: { default: "#FFBD39", active: "#FD015F" },
    },
    {
      width: 100,
      height1: 20,
      height2: 5,
      colors: { default: "#b0b0b0" },
    },
  ];

  const roundedRectangles2 = [
    {
      width: 185,
      height1: 100,
      height2: 100,
      colors: { default: "#b0b0b0" },
    },
    {
      width: 100,
      height1: 100,
      height2: 100,
      colors: { default: "#b0b0b0", active: "#FFA600" },
    },
  ];

  const rectangles = [
    {
      colors: { default: "#b0b0b0", active: "#246BEE" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#3DD695" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#FFFFFF" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#FF4800", active: "#246BEE" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#7DE8FF" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#3DD695" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#FAA600" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#FFFFFF" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#FC0105" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#FD015F" },
      size: { width: 110, height: 30 },
    },
    {
      colors: { default: "#FFD313", active: "#FF4800" },
      size: { width: 110, height: 30 },
    },
  ];

  const rectangles2 = [
    {
      colors: { default: "#b0b0b0", active: "#7DE8FF" },
      size: { width: 55, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#FFEA00" },
      size: { width: 150, height: 30 },
    },
    {
      colors: { default: "#FFBD39", active: "#FF4800" },
      size: { width: 300, height: 30 },
    },
    {
      colors: { default: "#b0b0b0", active: "#FFBD39" },
      size: { width: 150, height: 30 },
    },
    {
      colors: { default: "#FFEA00", active: "#FD015F" },
      size: { width: 50, height: 30 },
    },
    {
      colors: { default: "#3DD695", active: "#7DE8FF" },
      size: { width: 400, height: 30 },
    },
  ];

  const circles = [
    {
      colors: { default: "#b0b0b0", active: "#4285F4" },
    },
    {
      colors: { default: "#3DD695" },
    },
    {
      colors: { default: "#b0b0b0" },
    },
    {
      colors: { default: "#ffffff", active: "#EA4335" },
    },
    {
      colors: { default: "#b0b0b0", active: "#FFA600" },
    },
    {
      colors: { default: "#ffffff" },
    },
    {
      colors: { default: "#FC015E" },
      isMoving: [0, -100, 0],
    },
    {
      colors: { default: "#b0b0b0" },
    },
    {
      colors: { default: "#b0b0b0" },
    },
    {
      colors: { default: "#b0b0b0", active: "#4285F4" },
      isMoving: [0, 100, 0],
    },
    {
      colors: { default: "#ffffff" },
    },
    {
      colors: { default: "#b0b0b0", active: "#FFEA00" },
    },
    {
      colors: { default: "#b0b0b0" },
    },
    {
      colors: { default: "#ffffff" },
    },
    {
      colors: { default: "#b0b0b0", active: "#4285F4" },
      isMoving: [0, -100, 0],
      disableRandomDelay: true,
    },
    {
      colors: { default: "#5B5B5B" },
      isMoving: [0, -100, 0],
      disableRandomDelay: true,
    },
  ];

  return (
    <div className="p-2 min-w-[500px]">
      <div className="flex flex-row gap-2">
        <div className="flex-1">
          {/* First column */}
          <RoundedRectanglesContainerVertical shapesData={roundedRectangles} />
          <RectanglesContainer rectanglesData={rectangles} numRows={4} />
        </div>
        <div className="flex-1">
          {/* Second column */}
          <CirclesContainer circlesData={circles} />
          <RoundedRectanglesContainerHorizontal
            shapesData={roundedRectangles2}
          />
        </div>
      </div>
      <div>
        <RectanglesContainer rectanglesData={rectangles2} numRows={1} />
      </div>
    </div>
  );
};

export default Modular;
